var map = {
	"./blood-vessels/all-zones-inactive.svg": "9d62",
	"./dryness/all-zones-inactive.svg": "fe64",
	"./oiliness/all-zones-inactive.svg": "0884",
	"./pigmentation/all-zones-inactive.svg": "17d8",
	"./redness/all-zones-inactive.svg": "ced7",
	"./sagging/all-zones-inactive.svg": "8496",
	"./texture/all-zones-inactive.svg": "0c2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7572";